import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Form, FormGroup, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { CreatePropsTypes } from "../../../../Type/Application/Tasks/Tasks";
import { Cancel, CreateTagHeading, Save, TagColor, TagName } from "../../../../utils/Constant";

const CreateTag = ({ tagCallback, tagModal }: CreatePropsTypes) => {
  const { register, handleSubmit } = useForm();
  const tagToggle = () => {
    tagCallback(false);
  };
  const AddTag = () => {
    toast.success("Your Form Submitted");
  };
  return (
    <Modal className='modal-bookmark' isOpen={tagModal} toggle={tagToggle} size='lg'>
      <ModalHeader toggle={tagToggle} className='modal-header'>
        {CreateTagHeading}
      </ModalHeader>
      <ModalBody>
        <Form className='form-bookmark needs-validation' onSubmit={handleSubmit(AddTag)}>
          <Row>
            <Col md='12' className='mt-0'>
              <FormGroup>
                <Label>{TagName}</Label>
                <input className='form-control' type='text' {...register("name", { required: true })} />
              </FormGroup>
            </Col>
            <Col md='12' className='mt-0'>
              <FormGroup>
                <Label>{TagColor}</Label>
                <input className='form-color d-block' type='color' {...register("color", { required: true })} defaultValue='#6271EB' />
              </FormGroup>
            </Col>
          </Row>
          <Btn color='secondary'>{Save}</Btn>
          <Btn color='primary' onClick={tagToggle}>
            {Cancel}
          </Btn>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default CreateTag;
